import React, { Component } from "react";
import { connect } from "react-redux";

//Actions
import * as ACTIONS from "./../../actions/actionConstants";

//Components
import { Air, Lights, Schedule, Security } from "./dashboard_tabs";

//Deps
import { Paper, Tab, Tabs, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

//Icons
import EventIcon from "@material-ui/icons/Event"; //Schedule
import ToysIcon from "@material-ui/icons/Toys"; //Air
import SecurityIcon from "@material-ui/icons/Security"; //Security
import WbIncandescentIcon from "@material-ui/icons/WbIncandescent"; //Lights

function mapStateToProps(state) {
  return {
    email: state.user.currentUser.profile.email
  };
}

function mapDispatchToProps(dispatch) {
  return {
    generateData: data =>
      dispatch({ type: ACTIONS.GENERATE_DATA, payload: data })
  };
}

//Tab container
function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: "1em" }}>
      {props.children}
    </Typography>
  );
}

//Styles
const styles = theme => ({
  root: {
    width: "100%"
  },
  paper: {
    width: "100%",
    paddingTop: "1em"
  },
  icon: {
    paddingBottom: "10px"
  },
  container: {
    padding: "2em"
  },
  key: {
    fontSize: "1.5em",
    fontWeight: "bold",
    marginTop: "1em"
  }
});

//Data
const createData = () => {
  return {
    "Zone 1": {
      Temp: [{ value: 80 }, { value: 52 }, { value: 64 }],
      Blinds: [{ value: 100 }, { value: 100 }, { value: 50 }],
      Lights: [{ value: 80 }, { value: 48 }, { value: 20 }]
    },
    "Zone 2": {
      Temp: [{ value: 25 }, { value: 63 }, { value: 48 }],
      Blinds: [{ value: 63 }, { value: 41 }, { value: 83 }],
      Lights: [{ value: 31 }, { value: 43 }, { value: 97 }]
    },
    "Zone 3": {
      Temp: [{ value: 11 }, { value: 42 }, { value: 65 }],
      Blinds: [{ value: 15 }, { value: 63 }, { value: 42 }],
      Lights: [{ value: 36 }, { value: 65 }, { value: 42 }]
    }
  };
};

class UserDashboard extends Component {
  state = {
    value: 0
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  componentWillMount() {
    const { email, generateData } = this.props;
    const data = createData();

    if (
      email === "reception@demo.com" ||
      email === "lobby@demo.com" ||
      email === "office@demo.com"
    ) {
      generateData(data);
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            fullWidth
            indicatorColor="secondary"
            textColor="secondary">
            <Tab icon={<ToysIcon />} className={classes.icon} />
            <Tab icon={<WbIncandescentIcon />} className={classes.icon} />
            <Tab icon={<EventIcon />} className={classes.icon} />
            <Tab icon={<SecurityIcon />} className={classes.icon} />
          </Tabs>
        </Paper>
        <div className={classes.container}>
          {this.state.value === 0 && (
            <TabContainer>
              <Air />
            </TabContainer>
          )}
          {this.state.value === 1 && (
            <TabContainer>
              <Lights />
            </TabContainer>
          )}
          {this.state.value === 2 && (
            <TabContainer>
              <Schedule />
            </TabContainer>
          )}
          {this.state.value === 3 && (
            <TabContainer>
              <Security />
            </TabContainer>
          )}
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(UserDashboard));



// WEBPACK FOOTER //
// ./src/pages/user_dashboard/UserDashboard.js